import ProgressEmptySvg from "./progress-empty-state.svg";

const opensSansFonts = {
	"opensans-bold": require("./fonts/opensans/opensans-bold.ttf"),
	"opensans-bolditalic": require("./fonts/opensans/opensans-bolditalic.ttf"),
	"opensans-extrabold": require("./fonts/opensans/opensans-extrabold.ttf"),
	"opensans-extrabolditalic": require("./fonts/opensans/opensans-extrabolditalic.ttf"),
	"opensans-italic": require("./fonts/opensans/opensans-italic.ttf"),
	"opensans-light": require("./fonts/opensans/opensans-light.ttf"),
	"opensans-lightitalic": require("./fonts/opensans/opensans-lightitalic.ttf"),
	"opensans-regularitalic": require("./fonts/opensans/opensans-italic.ttf"),
	"opensans-regular": require("./fonts/opensans/opensans-regular.ttf"),
	"opensans-semibold": require("./fonts/opensans/opensans-semibold.ttf"),
	"opensans-semibolditalic": require("./fonts/opensans/opensans-semibolditalic.ttf"),
};
const greetStandardFonts = {
	"greetstandard-bold": require("./fonts/greetstandard/greetstandard-bold.ttf"),
	"greetstandard-regular": require("./fonts/greetstandard/greetstandard-regular.ttf"),
	"greetstandard-semibold": require("./fonts/greetstandard/greetstandard-semibold.ttf"),
	"greetstandard-semibolditalic": require("./fonts/greetstandard/greetstandard-semibolditalic.ttf"),
	"greetstandard-bolditalic": require("./fonts/greetstandard/greetstandard-bolditalic.ttf"),
	"greetstandard-regularitalic": require("./fonts/greetstandard/greetstandard-regularitalic.ttf"),
};

const beausiteFonts = {
	"beausite-regular": require("./fonts/beausite/beausite-regular.ttf"),
	"beausite-bold": require("./fonts/beausite/beausite-bold.ttf"),
	"beausite-bolditalic": require("./fonts/beausite/beausite-bolditalic.ttf"),
	"beausite-semibold": require("./fonts/beausite/beausite-semibold.ttf"),
	"beausite-semibolditalic": require("./fonts/beausite/beausite-semibolditalic.ttf"),
};

const sourceSansProFonts = {
	"sourcesanspro-regular": require("./fonts/sourcesanspro/regular.otf"),
	"sourcesanspro-bold": require("./fonts/sourcesanspro/bold.otf"),
	"sourcesanspro-bolditalic": require("./fonts/sourcesanspro/bolditalic.otf"),
	"sourcesanspro-semibold": require("./fonts/sourcesanspro/semibold.otf"),
	"sourcesanspro-semibolditalic": require("./fonts/sourcesanspro/semibolditalic.otf"),
};

const calibriFonts = {
	"calibri-regular": require("./fonts/calibri/calibri-regular.ttf"),
	"calibri-bold": require("./fonts/calibri/calibri-bold.ttf"),
	"calibri-bolditalic": require("./fonts/calibri/calibri-bolditalic.ttf"),
	"calibri-semibold": require("./fonts/calibri/calibri-semibold.ttf"),
	"calibri-semibolditalic": require("./fonts/calibri/calibri-semibolditalic.ttf"),
	"calibri-italic": require("./fonts/calibri/calibri-italic.ttf"),
};

const cambridgeSansFonts = {
	"cambridgesans-bold": require("./fonts/cambridgesans/cambridgesans-bold.ttf"),
	"cambridgesans-regular": require("./fonts/cambridgesans/cambridgesans-regular.ttf"),
	"cambridgesans-semibold": require("./fonts/cambridgesans/cambridgesans-semibold.ttf"),
	"cambridgesans-semibolditalic": require("./fonts/cambridgesans/cambridgesans-semibolditalic.ttf"),
	"cambridgesans-bolditalic": require("./fonts/cambridgesans/cambridgesans-bolditalic.ttf"),
	"cambridgesans-regularitalic": require("./fonts/cambridgesans/cambridgesans-regularitalic.ttf"),
	"cambridgesans-light": require("./fonts/cambridgesans/cambridgesans-light.ttf"),
	"cambridgesans-lightitalic": require("./fonts/cambridgesans/cambridgesans-lightitalic.ttf"),
};

const notoserifFonts = {
	"notoserif-bold": require("./fonts/notoserif/notoserif_bold.ttf"),
	"notoserif-extrabold": require("./fonts/notoserif/notoserif_extrabold.ttf"),
	"notoserif-extrabolditalic": require("./fonts/notoserif/notoserif_extrabolditalic.ttf"),
	"notoserif-italic": require("./fonts/notoserif/notoserif_italic.ttf"),
	"notoserif-light": require("./fonts/notoserif/notoserif_light.ttf"),
	"notoserif-lightitalic": require("./fonts/notoserif/notoserif_lightitalic.ttf"),
	"notoserif-regular": require("./fonts/notoserif/notoserif_regular.ttf"),
	"notoserif-semibold": require("./fonts/notoserif/notoserif_semibold.ttf"),
	"notoserif-semibolditalic": require("./fonts/notoserif/notoserif_semibolditalic.ttf"),
};

const plusJakartaSansFonts = {
	"plusjakartasans-regular": require("./fonts/plusjakartasans/plusjakartasans-regular.ttf"),
	"plusjakartasans-semibold": require("./fonts/plusjakartasans/plusjakartasans-semibold.ttf"),
	"plusjakartasans-bold": require("./fonts/plusjakartasans/plusjakartasans-bold.ttf"),
	"plusjakartasans-regularitalic": require("./fonts/plusjakartasans/plusjakartasans-italic.ttf"),
	"plusjakartasans-bolditalic": require("./fonts/plusjakartasans/plusjakartasans-bolditalic.ttf"),
};

const customFonts = {
	MaterialDesignIcons: require("@react-native-vector-icons/material-design-icons/fonts/MaterialDesignIcons.ttf"),
	memorangicons: require("./fonts/memorangicons.ttf"),
	pearsonicons: require("./fonts/pearsonicons.ttf"),
	...beausiteFonts,
	...opensSansFonts,
	...greetStandardFonts,
	...sourceSansProFonts,
	...calibriFonts,
	...notoserifFonts,
	...cambridgeSansFonts,
	...plusJakartaSansFonts,
};

export { customFonts, ProgressEmptySvg };
